export const MEDIA_VIDEO_IDS = [
    "BLgzXeBtMFo",
    "gCGuNMvqXr0",
    "if9K_Mrk8GU",
    "flm5SLe7QLg",
    "Tv4ULXqK6H0",
] as const;
